export default {
  namespaced: true,
  state() {
    return {
      routeName: '',
      linkName: '',
      isDashboard: true,
      isProfile: false,
      showSidebar: true,
      showJournalSidebar: true,
      showFull: true,
      showLogs: false,
      showSubmenu: false,
    }
  },
  mutations: {
    SET_ROUTE_NAME(state,name) {
      state.routeName = name
    },
    SET_LINK_NAME(state,name) {
      state.linkName = name
    },
    SET_DASHBOARD(state,data) {
      state.isDashboard = data
    },
    SET_PROFILE(state,data) {
      state.isProfile = data
    },
    SET_SHOW_SIDEBAR(state,data) {
      state.showSidebar = data
    },
    SET_SHOW_JOURNAL_SIDEBAR(state,data) {
      state.showJournalSidebar = data
    },
    SET_SHOW_FULL(state,data) {
      state.showFull = data
    },
    SET_SHOW_LOGS(state, data) {
      state.showLogs = data
    },
    SET_SHOW_SUBMENU(state,data) {
      state.showSubmenu = data
    }
  },
  getters: {
    getRouteName(state) {
      return state.routeName
    }
  }
}
